var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "34E7CA0D-4E01-47C2-9825-8F70D0CCF8D2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CNC---Cuisine",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Preparer-+-commande-+-menu-statut",
    transform: "translate(-1378.000000, -824.000000)",
    fill: "#55DA98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(1056.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(30.000000, 791.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top-nav"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Atom/icons/check",
    transform: "translate(292.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,0 C17.8509942,0 23,5.14900575 23,11.5 C23,17.8509942 17.8509942,23 11.5,23 C5.14900575,23 0,17.8509942 0,11.5 C0,5.14930784 5.14930784,0 11.5,0 Z M5.4275424,12.7191935 C4.05385973,11.1974728 6.31066827,9.05451219 7.68527826,10.5771838 L9.91086674,13.0415409 L15.2615524,6.57303929 C16.5709403,4.98697589 18.9251183,7.03072825 17.6163486,8.61615774 L11.1751246,16.4032092 C10.5677244,17.1353848 9.49820554,17.226986 8.83547475,16.4929087 L5.4275424,12.7191935 L5.4275424,12.7191935 Z"
  }))))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/selected.cc6c77b70b2e9320fa12253ccde4d1d7.svg";